export const LockersDHL = 'LockersDHL'
export const LockersDeBuren = 'LockersDeBuren'
export const LockersSmartmile = 'LockersSmartmile'
export const ParcelStation = 'ParcelStation'
